import React from 'react';
import { PartnershipCardProps } from '@/components/card/types';
import clsx from 'clsx';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { Link } from '@/components/link/Link';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import '../style.css';
import { renameDomProps } from '@/utils/sanitizeDomProps';

const PartnershipCard: React.FC<PartnershipCardProps> = React.memo(
  ({
    image,
    title,
    description,
    link,
    className,
    cardHeight = 'h-96',
    ...rest
  }) => {
    const hasOnlyImage = image && !title && !description;

    const renamedProps = renameDomProps(rest);
    return (
      <div
        className={clsx(
          'partnership-card flex flex-col overflow-hidden rounded-xl border border-neutral-25 bg-white text-brand-700',
          {
            'bg-neutral-25': hasOnlyImage,
          },
          className,
        )}
        {...renamedProps}
      >
        {image && (
          <div className={`w-full overflow-hidden`}>
            <BaseImage
              {...image}
              className="h-full w-full"
              classNameImage="w-full h-full aspect-[16/10] object-cover"
              sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
            />
          </div>
        )}
        <div className="hidden h-96">test</div>

        {title && description && (
          <div className="flex flex-col gap-4 self-stretch bg-white p-6">
            {title && <h3 className="text-xl font-medium">{title}</h3>}

            <div className="overflow-hidden">
              {description && (
                <div
                  className="serialize-description m-0 text-base"
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3, // Limit to 3 lines
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    height: '76px', // Ensure the specified height
                    fontSize: '1.3rem',
                    margin: '0',
                    background: 'white',
                  }}
                >
                  <SerializeDescription description={description} />
                </div>
              )}
            </div>

            {link && <Link {...link}>{link.title}</Link>}
          </div>
        )}
      </div>
    );
  },
);

PartnershipCard.displayName = 'PartnershipCard';

export default PartnershipCard;
